import React, { useEffect, useState } from 'react'
import { Skeleton, Table } from 'antd'
import Api from 'api'
import { formatAmount, formateDate } from 'utils'

function ProgramServiceDetail({ id, name, setValue, type }) {
  const [loading, setLoading] = useState()
  const [report, setReport] = useState()

  useEffect(() => {
    setLoading(true)
    Api.get(
      `programServices/orgProgramServicePaymentById?id=${id}&type=${
        type === 'Services' ? 'service' : 'program'
      }&subtype=${
        type === 'Services' ? 'service' : type === 'Class' ? 'class' : 'program'
      }`,
    )
      .then((res) => {
        const data = res.results
        setReport(data)
        setValue(data)
        setLoading(false)
      })
      .catch((error) => {
        console.log('error', error)
        setLoading(false)
      })
    // eslint-disable-next-line
  }, [])

  const TotalAmount = (dataArray) => {
    const total = dataArray.reduce((acc, obj) => acc + Number(obj.Amount), 0)
    return formatAmount(total)
  }

  const baseColumns = [
    {
      title: 'Title',
      render: () => name,
    },
    {
      title: 'Name',
      dataIndex: 'UserName',
      key: 'UserName',
    },
    {
      title: 'Email',
      dataIndex: 'UserEmail',
      key: 'UserEmail',
    },
    {
      title: 'Amount',
      dataIndex: 'Amount',
      key: 'Amount',
      render: formatAmount,
    },
    {
      title: 'Payment Date',
      dataIndex: 'PaymentDate',
      key: 'PaymentDate',
      render: formateDate,
    },
  ]

  // Additional columns for 'columnClasses'
  const additionalClassColumns = [
    {
      title: 'Age',
      dataIndex: 'Age',
      key: 'Age',
    },
    {
      title: 'Gender',
      dataIndex: 'Gender',
      key: 'Gender',
    },
  ]

  // Combine base columns with additional columns based on type
  const getColumns = (typeColumn) =>
    typeColumn === 'Class'
      ? [...baseColumns, ...additionalClassColumns]
      : baseColumns

  return (
    <Skeleton loading={loading} paragraph={{ rows: 12 }}>
      {report && report.length > 0 ? (
        <>
          <div className="t-flex t-items-center t-mb-8">
            <h1 className="t-font-semibold t-mx-2">{`Total amount of ${type}:`}</h1>
            <p className="t-font-semibold">{TotalAmount(report)}</p>
          </div>
          <div>
            <Table
              dataSource={report}
              columns={getColumns(type)}
              rowKey={(record) => record.id}
              // components={components}
              scroll={{ x: true }} // Enables horizontal scrolling
              pagination={false} // Disable default pagination
              // loading={loading}
            />
          </div>
        </>
      ) : (
        <div>No Data Found</div>
      )}
    </Skeleton>
  )
}

export default ProgramServiceDetail
